import { downloadBackup, restoreBackup, factoryReset } from "../backup-utils";
import { For, type Component } from "solid-js";
import { getPluginService } from "../services/plugin/plugin-service";
import { type PluginEntry } from "../types";

type SettingsPageProps = {
  plugins: Array<PluginEntry>;
};

export const SettingsPage: Component<SettingsPageProps> = (props) => {
  const handlePluginToggle = (pId: PluginEntry["id"]) => getPluginService().togglePlugin(pId);
  const sortedPlugins = () => getPluginService().sortPluginEntries(props.plugins);

  return (
    <div>
      <h3>Plugins</h3>
      <p class="SettingsPage__Hint">Disabled plugins will not be loaded on the next page reload.</p>
      <div class="SettingsPage__Plugins">
        <For each={sortedPlugins()}>
          {(plugin) => (
            <label class="SettingsPage__PluginToggle">
              <input type="checkbox" checked={plugin.enabled} onChange={() => handlePluginToggle(plugin.id)} />
              <span>{plugin.name}</span>
            </label>
          )}
        </For>
      </div>
      <h3>Backup management</h3>
      <p>Backup is made for active plugins only.</p>
      <div class="SettingsPage__Backup">
        <button
          onClick={async () => {
            try {
              await downloadBackup();
            } catch (error) {
              console.error("Failed to download backup:", error);
              alert("Failed to create backup. Please try again.");
            }
          }}
        >
          Download Backup
        </button>
        <button
          onClick={async () => {
            try {
              const result = await restoreBackup();
              alert(
                `Restore complete!\n\nImported: ${result.imported}\nSkipped (duplicates): ${result.skipped}\nErrors: ${result.errors}`,
              );
            } catch (error) {
              console.error("Failed to restore backup:", error);
              if (error instanceof Error && error.message === "File selection cancelled") {
                return; // User cancelled, don't show error
              }
              alert("Failed to restore backup. Please check the file and try again.");
            }
          }}
        >
          Restore Backup
        </button>
      </div>
      <h3>Danger Zone</h3>
      <button
        class="SettingsPage__ResetButton"
        onClick={async () => {
          try {
            const deletedCount = await factoryReset();
            alert(`Factory reset complete!\n\n${deletedCount} entries were deleted.`);
          } catch (error) {
            console.error("Failed to perform factory reset:", error);
            if (error instanceof Error && error.message === "Factory reset cancelled") {
              return; // User cancelled, don't show error
            }
            alert("Failed to perform factory reset. Please try again.");
          }
        }}
      >
        Factory Reset
      </button>
      <div class="SettingsPage__Version">
        <span>Saludio</span>
        <span>version {window.appVersion}</span>
        <span class="slogo" title="(C) Solova 2026, All rights reserved">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 450">
            <path d="M 450,450 H 305 C 355,375 350,300 300,225 250,150 245,75 300,0 h 150 z" />
            <path d="m 0,0 h 150 c -55,75 -50,150 0,225 50,75 55,150 0,225 H 0 Z" />
          </svg>
        </span>
      </div>
    </div>
  );
};
